import FeatherIcon from 'feather-icons-react';
import { Link } from 'react-router-dom';
import StatusBadge from 'components/custom/ui/StatusBadge';
import { Icon } from '@iconify/react';
import { getApprovalSettlementStatus } from 'helpers/status-badge';
import { currencyFormat } from 'helpers/utils';
import Badge from 'components/base/Badge';
import Button from 'components/base/Button';
import PaymentSettlementPrint from 'views/payment/trucker-payment/PaymentSettlementPrint';
import { formatDate } from 'services/utils';
import { masterPaths } from 'constants/pagePath';
// import PaymentSettlementPrint from 'views/payment/trucker-payment/PaymentSettlementPrint';

const TruckerPaymentApprovalListColumn = (
  handleApproveDetail,
  handleLoading
) => [
  {
    accessorKey: 'settlement_no',
    // accessorFn: ({ user_name, user_type }) => `${user_name} ${user_type}`,
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <div className="px-1 py-1 bg-primary-100 rounded me-2">
            <Icon
              icon="fluent:number-symbol-16-regular"
              fontSize={16}
              className="text-info-600 dark__text-info-300"
            />
          </div>
          <span>Settlement No.</span>
        </div>
      );
    },

    cell: ({ row: { original } }) => {
      const { settlement_no } = original;
      return (
        // <div className="fs-8 fw-bold" >
        //   {settlement_no}
        // </div>
        <div className="fs-8 text-primary">{settlement_no}</div>
      );
    },
    meta: {
      headerProps: {
        className: 'ps-0 me-1 bg-white'
      },
      cellProps: {
        className: 'white-space-nowrap ps-0 me-1 bg-white'
      }
    }
  },
  {
    accessorKey: 'settlement_date',
    // header: 'Contact Person',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <div className="px-1 py-1 bg-primary-100 rounded me-2">
            <Icon
              icon="fluent:number-symbol-16-regular"
              fontSize={16}
              className="text-info-600 dark__text-info-300"
            />
          </div>
          <span>Date</span>
        </div>
      );
    },
    cell: ({ row: { original } }) => {
      const { settlement_date } = original;
      return (
        <div className="d-flex align-items-center">
          <div>
            <div className="fs-8">
              {formatDate(settlement_date, 'DD MMM YY')}
            </div>
          </div>
        </div>
      );
    },
    meta: {
      headerProps: {
        style: { width: '15%' },
        className: 'ps-0 '
      },
      cellProps: { className: 'white-space-nowrap ps-0 ' }
    }
  },
  {
    accessorFn: original => {
      return `${original.trucker_name} ${original.trucker_type}`;
    },
    id: 'trucker_name',
    // header: 'vehicle type',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <div className="px-1 py-1 bg-primary-100 rounded me-2">
            <Icon
              icon="fluent:number-symbol-16-regular"
              fontSize={16}
              className="text-info-600 dark__text-info-300"
            />
          </div>
          <span>Trucker Name</span>
        </div>
      );
    },
    cell: ({ row: { original } }) => {
      const { trucker_name, trucker_id, trucker_type } = original;
      return (
        <div>
          <div className="d-flex">
            <Link
              to={`${masterPaths.vendor.trucker.detail(trucker_id)}`}
              className="fs-8 fw-bold"
            >
              {trucker_name}
            </Link>
          </div>
          <Badge
            className="fw-semi-bold fs-11 d-block w-max-content"
            bg="secondary"
            variant="phoenix"
          >
            {trucker_type}
          </Badge>
        </div>
      );
    },
    meta: {
      headerProps: {
        // style: { width: '15%', minWidth: '80px' },
        className: 'ps-3 pe-3 '
      },
      cellProps: {
        className: 'white-space-nowrap fw-semi-bold ps-3 '
      }
    }
  },
  {
    accessorKey: 'contact_no',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <div className="px-1 py-1 bg-primary-100 rounded me-2">
            <Icon
              icon="fluent:number-symbol-16-regular"
              fontSize={16}
              className="text-info-600 dark__text-info-300"
            />
          </div>
          <span>Contact No.</span>
        </div>
      );
    },

    cell: ({ row: { original } }) => {
      const { trucker_phone } = original;
      return (
        <div className="d-flex align-items-center">
          <div>
            <div className="d-flex align-items-center">
              <Link
                to={`tel:${trucker_phone}`}
                className="mb-0 text-800 fw-semi-bold fs-8 me-2"
              >
                {trucker_phone}
              </Link>
            </div>
          </div>
        </div>
      );
    }
  },
  {
    accessorKey: 'no_of_challans',
    // header: 'Contact Person',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <div className="px-1 py-1 bg-primary-100 rounded me-2">
            <Icon
              icon="mdi:contact-outline"
              fontSize={16}
              className="text-info-600 dark__text-info-300"
            />
          </div>
          <span>No. Challan</span>
        </div>
      );
    },
    cell: ({ row: { original } }) => {
      const { no_of_challans } = original;
      return (
        <div className="d-flex align-items-center">
          <div>
            <div className="fs-8 fw-bold">{no_of_challans}</div>
          </div>
        </div>
      );
    },
    meta: {
      headerProps: {
        // style: { width: '25%' },
        className: 'ps-0 '
      },
      cellProps: { className: 'white-space-nowrap ps-0 ' }
    }
  },
  {
    accessorKey: 'do_numbers',
    // header: 'trucker',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <div className="px-1 py-1 bg-info-100 rounded me-2">
            <Icon
              icon="fluent:calendar-agenda-24-regular"
              fontSize={16}
              className="text-info-600 dark__text-info-300"
            />
          </div>
          <span>Do Number</span>
        </div>
      );
    },
    cell: ({ row: { original } }) => {
      const { do_numbers } = original;
      return <div className="text-700">{do_numbers}</div>;
    },
    meta: {
      headerProps: {
        // style: { width: '15%', minWidth: '80px' },
        className: 'ps-3 pe-3 '
      },
      cellProps: {
        className: 'white-space-nowrap fw-semi-bold ps-3 '
      }
    }
  },

  {
    accessorKey: 'tds_charges',
    // header: 'trucker',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <div className="px-1 py-1 bg-info-100 rounded me-2">
            <FeatherIcon
              icon="dollar-sign"
              size={14}
              className="text-info-600 dark__text-info-300"
            />
          </div>
          <span>TDS Amount</span>
        </div>
      );
    },
    // cell: ({ row: { original } }) => {
    //   const { tds_charges } = original;
    //   return <div className="text-700">{tds_charges}</div>;
    // },
    cell: ({ row: { original } }) => (
      <Badge
        bg="primary"
        className="fs-8 font-outfit fw-normal"
        variant="phoenix"
      >
        {currencyFormat(original.tds_charges)}
      </Badge>
    ),
    meta: {
      headerProps: {
        // style: { width: '15%', minWidth: '80px' },
        className: 'ps-3 pe-3 '
      },
      cellProps: {
        className: 'white-space-nowrap fw-semi-bold ps-3 '
      }
    }
  },
  {
    accessorKey: 'total_payable_amount',
    // header: 'trucker',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <div className="px-1 py-1 bg-info-100 rounded me-2">
            <FeatherIcon
              icon="dollar-sign"
              size={14}
              className="text-info-600 dark__text-info-300"
            />
          </div>
          <span>Payable Amount</span>
        </div>
      );
    },
    cell: ({ row: { original } }) => (
      <Badge
        bg="primary"
        className="fs-8 font-outfit fw-normal"
        variant="phoenix"
      >
        {currencyFormat(original.total_payable_amount)}
      </Badge>
    ),
    meta: {
      headerProps: {
        // style: { width: '15%', minWidth: '80px' },
        className: 'ps-3 pe-3 '
      },
      cellProps: {
        className: 'white-space-nowrap fw-semi-bold ps-3 '
      }
    }
  },

  {
    accessorKey: 'created_by_name',
    // header: 'Contact Person',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <div className="px-1 py-1 bg-primary-100 rounded me-2">
            <Icon
              icon="mdi:contact-outline"
              fontSize={16}
              className="text-info-600 dark__text-info-300"
            />
          </div>
          <span>Created By</span>
        </div>
      );
    },
    cell: ({ row: { original } }) => {
      const { created_by_name } = original;
      return (
        <div className="d-flex align-items-center">
          <div>
            <div className="fs-8 fw-bold">{created_by_name}</div>
          </div>
        </div>
      );
    },
    meta: {
      headerProps: {
        // style: { width: '25%' },
        className: 'ps-0 '
      },
      cellProps: { className: 'white-space-nowrap ps-0 ' }
    }
  },
  {
    accessorKey: 'checker_by_name',
    // header: 'Contact Person',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <div className="px-1 py-1 bg-primary-100 rounded me-2">
            <Icon
              icon="mdi:contact-outline"
              fontSize={16}
              className="text-info-600 dark__text-info-300"
            />
          </div>
          <span>Checked By</span>
        </div>
      );
    },
    cell: ({ row: { original } }) => {
      const { checker_by_name } = original;
      return (
        <div className="d-flex align-items-center">
          <div>
            <div className="fs-8 fw-bold">{checker_by_name}</div>
          </div>
        </div>
      );
    },
    meta: {
      headerProps: {
        // style: { width: '25%' },
        className: 'ps-0 '
      },
      cellProps: { className: 'white-space-nowrap ps-0 ' }
    }
  },
  {
    accessorKey: 'status',
    header: 'status',
    cell: ({ row: { original } }) => (
      <StatusBadge
        status={original.status}
        getStatus={getApprovalSettlementStatus}
        lastComment={original.last_comment}
      />
    ),
    meta: {
      headerProps: {
        style: { width: '10%' }
      }
    }
  },
  {
    id: 'action',
    header: 'Action',
    cell: ({ row: { original } }) => (
      <div className="d-flex gap-2 justify-content-end">
        <Button
          variant="phoenix-warning"
          className="p-2 fs-9 fw-medium text-nowrap"
          onClick={() => handleApproveDetail(original)}
          disabled={original.status !== 'First_Approved'}
        >
          Approval
        </Button>
        <Button
          variant="phoenix-secondary"
          className="p-2 fs-9 fw-medium text-nowrap"
          onClick={() => handleApproveDetail(original, 'ViewOnly')}
        >
          View
        </Button>
        <PaymentSettlementPrint
          id={8045}
          handleLoading={handleLoading}
          data={original}
        />
      </div>
    ),
    meta: {
      headerProps: { style: { width: '15%' }, className: 'text-center' },
      cellProps: { className: 'text-end' }
    }
  }
];

export default TruckerPaymentApprovalListColumn;
